import { render, staticRenderFns } from "./IntlTel.vue?vue&type=template&id=52377d77&scoped=true&"
import script from "./IntlTel.vue?vue&type=script&lang=js&"
export * from "./IntlTel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52377d77",
  null
  
)

export default component.exports